import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridInitialState } from '@mui/x-data-grid';
import DefaultActions from 'components/DataGrid/DefaultActions';
import { ENTITY_TYPE } from 'common/constants';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'firstName', headerName: 'First name', width: 150 },
  { field: 'lastName', headerName: 'Last name', width: 150 },
  { field: 'age', headerName: 'Age', type: 'number', width: 110 },
  {
    field: 'actions',
    headerName: '',
    flex: 1,
    renderCell: (params) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end'}}>
        <DefaultActions
          row={params.row}
          entityType={ENTITY_TYPE.ANY}
          editScopes={[]}
          viewScopes={[]}
          deleteScopes={[]}
          onEdit={() => console.log('Edit', params.row.id)}
          onView={() => console.log('View', params.row.id)}
          onDelete={() => console.log('Delete', params.row.id)}
        />
      </Box>
    ),
  },
];

const generateRows = (count: number) =>
  Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    firstName: `Name${i + 1}`,
    lastName: `Surname${i + 1}`,
    age: 20 + ((i + 1) % 30),
  }));

const PAGE_SIZE = 10;
const TOTAL_ROWS = 57;

const ShowcaseDataGrid: React.FC = () => {
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(generateRows(PAGE_SIZE));

  const handlePageChange = (params: any) => {
    setLoading(true);
    setTimeout(() => {
      setRows(generateRows(PAGE_SIZE).map((row, idx) => ({
        ...row,
        id: page * PAGE_SIZE + idx + 1,
      })));
      setLoading(false);
    }, 800);
    setPage(params.page);
  };

  const INITIAL_STATE: GridInitialState = {
    pagination: {
      paginationModel: {
        page: 0,
        pageSize: PAGE_SIZE,
      },
    },
  };

  const handleSortModelChange = (sortModel: any) => {
    console.log('Sort model changed:', sortModel);
    // Implement sorting logic here if needed
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        DataGrid Showcase
      </Typography>
      <Box style={{ width: '100%', display: 'flex' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          rowCount={TOTAL_ROWS}
          loading={loading}
          initialState={INITIAL_STATE}
          onPaginationModelChange={handlePageChange}
          onSortModelChange={handleSortModelChange}
        />
      </Box>
    </Box>
  );
};

export default ShowcaseDataGrid;
